import React from 'react';
import '../tailwind.css';
import '../stitches.css';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { FaFileWord, FaFilePdf, FaDownload } from "react-icons/fa";

const word_docs = [
  "20200309_ATACseqDocuments.docx","20200309_Quality_Control_Parameter.docx","20200309_RNAseqDocuments.docx","Common_File_Formats_Used_by_the_TaRGET_II_Consortium.docx","Data_Use_Policy_for_External_Users.docx","Data_release_policies.docx","Experimental_procedures.docx"
];

const library_pdfs = ["Aylor_ATACseq_Omni.pdf",
"Aylor_RNAseq_Kapa.pdf",
"Bartolomei_ATACseq_FastATAC.pdf",
"Bartolomei_ATACseq_Omni.pdf",
"Bartolomei_RNAseq_Kapa.pdf",
"Bartolomei_RNAseq_ScriptSeq.pdf",
"Biswal_ATACseq_FastATAC.pdf",
"Biswal_ATACseq_Omni.pdf",
"Biswal_RNAseq_TruSeq.pdf",
"Dolinoy_ATACseq_MichiganEpiCore.pdf",
"Dolinoy_RNAseq_TruSeq.pdf",
"Mutlu_ATACseq_FastATAC.pdf",
"Mutlu_ATACseq_Omni.pdf",
"Mutlu_RNAseq_TruSeq.pdf",
"Walker_ATACseq_Omni.pdf",
"Walker_RNAseq_Truseq.pdf",
"ZhibinWang_ATACseq_Omni.pdf",
"ZhibinWang_RNAseq_TruSeq.pdf"];


const sops = ["SOP_Blood_Processing.pdf",
"SOP_Mouse_liver_collection.pdf",
"SOP_Whole_mouse_perfusion_blood_protocol.pdf"];

const Documents = () => {
  return (
    <div className='flex flex-col justify-between h-screen pt-4'>
      <div className='border-b-2 border-grey-light'>
        <Nav/>
      </div>
      <section className="my-8 font-sans container m-auto max-w-xl bg-grey-lighter">
        <div className="text-center">
          <h1 className="my-4 pt-4 font-medium">Documents and Protocols</h1>
          <p className="leading-normal mb-4 max-w-sm m-auto"></p>
        </div>
        <div className="flex flex-col sm:flex-row flex-wrap my-8 p-4">
          {word_docs.map((d, index) => <div key={`word-doc-${index}`} className="w-full sm:w-1/2 md:w-1/3 flex flex-col items-center justify-center h-48 md:h-64 border-gray-300 border-r border-b hover:shadow-md hover:border-0 bg-white hover:transform-scale-subtle transition-normal hover:show-child">
            <div className="w-12 h-12 rounded-full bg-gray-300" alt="">
            <h1 className="text-blue"><FaFileWord/></h1>
            </div>
            <h5 className="mt-4 mb-1 px-4">{d.replace(/_/g, ' ')}</h5>
            <span>
                <a href={`/docs/${d}`} className="text-gray-500 no-underline hover:text-black">
                  <FaDownload/>
                </a>
              </span>
            {/* <p className="mt-4 text-center text-gray-700 leading-normal px-6 hidden hover:block">{d.replace(/_/g, ' ')}</p> */}
          </div>)}
        </div>
      </section>

      <section className='container m-auto border-b-4 my-8'>
        <h3>Standard Operating Procedures</h3>
        {sops.map((d, index) => <div className="flex py-3">
          <div className="w-1/8">
            {/* <a href="#" className="block rounded-full h-12 w-12 mr-2 bg-gray-300"></a> */}
          </div>
          <div className="w-7/8">
            {/* <div>
              <span className="font-bold"><a href="#" className="text-black">Natalie Rushman</a></span>
              <span className="text-gray-700">@natalie</span>
              <span className="text-gray-700">·</span>
              <span className="text-gray-700">May 26</span>
            </div> */}
            <div className="">
          <p className="my-3 text-sm">{d}</p>
              <div className="pb-2 flex">
              <h1 className="text-red mx-8"><FaFilePdf/></h1>
                <span>
                <a href={`/docs/standardised_operating_procedures/${d}`} target="_blank" rel="noopener noreferrer" className="no-underline hover:text-blue">
                  <FaDownload/>
                </a>
              </span>
              </div>
            </div>
          </div>
        </div>)}
      </section>
      
      <ul className="font-sans list-none p-0 container m-auto text-gray-900 ">
        <h3>Library Construction Protocols</h3>

        <hr/>
        {library_pdfs.map((d, index) => <li key={`library-${index}`} className="border-b inline-block flex justify-between items-center py-4">
          <div className="flex items-start w-2/5 ">
            <div className="w-10 h-10 rounded mr-3">
              <div className="rounded-full h-10 w-10 bg-gray-300 m-auto"></div>
            </div>
            <div className="flex-1 overflow-hidden">
              {/* <div>
                <span className="font-bold">Kotlin Lee</span>
                <span className="text-gray-700 text-xs">@kotlin</span>
              </div> */}
              <h1 className="text-red"><FaFilePdf/></h1>
              {/* <p className="text-black leading-normal">1-332-435-1322</p> */}
            </div>
          </div>
          <p className="w-2/5">{d}</p>
          {/* <label for="status" className="font-bold w-1/5 text-right"><FaFilePdf/></label> */}
          <span>
                <a href={`/docs/library_construction_protocol_perlab/${d}`} target="_blank" rel="noopener noreferrer" className="no-underline hover:text-blue">
                  <FaDownload/>
                </a>
              </span>
        </li>)}
      </ul>
      <div
        className="antialiased font-sans w-full bg-grey-lighter text-left text-black py-8"></div>
      <Footer/>
    </div>
  );
}

export default Documents;